import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PresalesActivity {
  id: string;
  presalesProjectId: string;
  type: string;
  title: string;
  description?: string;
  activityDate: string;
  authorName?: string;
  authorEmail?: string;
  /** When the follow-up is due. Null for an entry that is only a record. */
  targetDate?: string | null;
  ownerId?: string | null;
  ownerName?: string | null;
  /** To Start, InProgress, On Hold or Closed. Null when not being tracked. */
  progress?: string | null;
  progressPercentage?: number;
  createdDate?: string;
  updatedDate?: string;
}

export interface CreatePresalesActivityDto {
  presalesProjectId: string;
  type: string;
  title: string;
  description?: string;
  activityDate: string;
  authorName?: string;
  authorEmail?: string;
  targetDate?: string | null;
  ownerId?: string | null;
  progress?: string | null;
  progressPercentage?: number;
}

@Injectable({ providedIn: 'root' })
export class PresalesActivityService {
  private apiUrl = `${environment.apiUrl}/PresalesActivity`;

  constructor(private http: HttpClient) {}

  getByPresalesProjectId(presalesProjectId: string): Observable<PresalesActivity[]> {
    return this.http.get<PresalesActivity[]>(`${this.apiUrl}/presales-project/${presalesProjectId}`);
  }

  addItem(item: CreatePresalesActivityDto): Observable<PresalesActivity> {
    return this.http.post<PresalesActivity>(this.apiUrl, item);
  }

  updateItem(id: string, item: PresalesActivity): Observable<PresalesActivity> {
    return this.http.put<PresalesActivity>(`${this.apiUrl}/${id}`, item);
  }

  deleteItem(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
